export const serviceType = {
  COD: 0,
  NON_COD: 1,
};

export const pickUpType = {
  PICK_UP: 1,
  DROP_OFF: 0,
};

export const vehicle = {
  TRUCK: 2,
  MOBIL: 1,
  MOTOR: 0,
};

export const contactUsageType = {
  SHIPPER: 1,
  RECEIVER: 0,
};

export const goodsTypes = {
  'Document/Paket': 1,
  Paket: 2,
  Document: 3,
};
